"use strict";
exports.__esModule = true;
exports.JobBuilder = exports.JobOutput = exports.JobState = exports.JobType = void 0;
var core_common_domain_1 = require("@jewelutions/core-common-domain");
var core_common_logic_1 = require("@jewelutions/core-common-logic");
var CrmDefaults_1 = require("../CrmDefaults");
var JobType;
(function (JobType) {
    JobType["ORDERS_SYNC_SHOP_TO_PLATFORM"] = "ORDERS_SYNC_SHOP_TO_PLATFORM";
    JobType["ORDERS_SYNC_PLATFORM_TO_SHOP"] = "ORDERS_SYNC_PLATFORM_TO_SHOP";
    JobType["MERCHANT_CATALOG_SYNC_PLATFORM_TO_SHOP"] = "MERCHANT_CATALOG_SYNC_PLATFORM_TO_SHOP";
    JobType["MERCHANT_SHOP_RESET_STATE"] = "MERCHANT_SHOP_RESET_STATE";
    JobType["ACCESSORY_CAD_MODEL_IMPORT"] = "ACCESSORY_CAD_MODEL_IMPORT";
    JobType["PIECE_CAD_MODEL_IMPORT"] = "PIECE_CAD_MODEL_IMPORT";
    JobType["ACCESSORY_IMAGES_GENERATE"] = "ACCESSORY_IMAGES_GENERATE";
    JobType["PIECE_IMAGES_GENERATE"] = "PIECE_IMAGES_GENERATE";
    JobType["MERCHANT_CATALOG_IMAGES_GENERATE"] = "MERCHANT_CATALOG_IMAGES_GENERATE";
})(JobType = exports.JobType || (exports.JobType = {}));
var JobState;
(function (JobState) {
    JobState["CREATED"] = "CREATED";
    JobState["STARTED"] = "STARTED";
    JobState["FINISHED_SUCCESS"] = "FINISHED_SUCCESS";
    JobState["FINISHED_FAILED"] = "FINISHED_FAILED";
})(JobState = exports.JobState || (exports.JobState = {}));
var JobOutput = /** @class */ (function () {
    function JobOutput() {
    }
    JobOutput.hasErrors = function (jobOutput) {
        if (jobOutput === undefined) {
            throw new core_common_domain_1.Exception("Cannot check hasErrors on undefined jobOutput");
        }
        return jobOutput.errors.length > 0;
    };
    JobOutput.concat = function (first, second) {
        if (first === undefined || second === undefined) {
            throw new core_common_domain_1.Exception("Cannot concatenate two job outputs when one of then is undefined");
        }
        var logs = [];
        logs.push.apply(logs, first.logs);
        logs.push.apply(logs, second.logs);
        var errors = [];
        errors.push.apply(errors, first.errors);
        errors.push.apply(errors, second.errors);
        return {
            data: second.data,
            logs: logs,
            errors: errors
        };
    };
    JobOutput.EMPTY = {
        data: {},
        logs: [],
        errors: []
    };
    return JobOutput;
}());
exports.JobOutput = JobOutput;
var JobBuilder = /** @class */ (function () {
    function JobBuilder(job) {
        this.job = job;
    }
    JobBuilder.initialiseJobMerchantCatalogSyncPlatformToShop = function (shopConnection, channelShopReferenceCollection, merchantChannel, previousDesignerCatalog, futureDesignerCatalog) {
        var input = {
            merchantCatalogSyncPlatformToShop: {
                shopConnection: shopConnection,
                channelShopReferenceCollection: channelShopReferenceCollection,
                merchantChannel: merchantChannel,
                previousDesignerCatalog: previousDesignerCatalog,
                futureDesignerCatalog: futureDesignerCatalog
            }
        };
        return new JobBuilder({
            id: core_common_logic_1.CommonLogic.generateUUIDv4(),
            partyId: merchantChannel.partyId,
            merchantChannelId: merchantChannel.id,
            type: JobType.MERCHANT_CATALOG_SYNC_PLATFORM_TO_SHOP,
            state: JobState.CREATED,
            input: input,
            output: JobOutput.EMPTY,
            scheduledToStartAt: core_common_logic_1.CommonLogic.nowToDateTime(),
            createdAt: core_common_logic_1.CommonLogic.nowToDateTime()
        });
    };
    JobBuilder.initialiseMerchantShopResetState = function (merchantPartyId, merchantChannelId, shopConnection, collectionTitle) {
        var input = {
            merchantShopResetState: {
                shopConnection: shopConnection,
                collectionTitle: collectionTitle
            }
        };
        return new JobBuilder({
            id: core_common_logic_1.CommonLogic.generateUUIDv4(),
            partyId: merchantPartyId,
            merchantChannelId: merchantChannelId,
            type: JobType.MERCHANT_SHOP_RESET_STATE,
            state: JobState.CREATED,
            input: input,
            output: JobOutput.EMPTY,
            scheduledToStartAt: core_common_logic_1.CommonLogic.nowToDateTime(),
            createdAt: core_common_logic_1.CommonLogic.nowToDateTime()
        });
    };
    JobBuilder.initialiseOrdersSyncShopToPlatform = function (merchantPartyId, merchantChannelId, shopConnection) {
        var input = {
            ordersSyncShopToPlatform: {
                shopConnection: shopConnection,
                merchantPartyId: merchantPartyId,
                merchantChannelId: merchantChannelId
            }
        };
        return new JobBuilder({
            id: core_common_logic_1.CommonLogic.generateUUIDv4(),
            partyId: merchantPartyId,
            merchantChannelId: merchantChannelId,
            type: JobType.ORDERS_SYNC_SHOP_TO_PLATFORM,
            state: JobState.CREATED,
            input: input,
            output: JobOutput.EMPTY,
            scheduledToStartAt: core_common_logic_1.CommonLogic.nowToDateTime(),
            createdAt: core_common_logic_1.CommonLogic.nowToDateTime()
        });
    };
    JobBuilder.initialisePieceCadModelImport = function (pieceId, pieceModelId, cadFile) {
        var input = {
            pieceCadModelImport: {
                pieceId: pieceId,
                pieceModelId: pieceModelId,
                cadFile: cadFile
            }
        };
        return new JobBuilder({
            id: core_common_logic_1.CommonLogic.generateUUIDv4(),
            partyId: CrmDefaults_1.CrmDefaults.platformPartyId,
            type: JobType.PIECE_CAD_MODEL_IMPORT,
            state: JobState.CREATED,
            input: input,
            output: JobOutput.EMPTY,
            scheduledToStartAt: core_common_logic_1.CommonLogic.nowToDateTime(),
            createdAt: core_common_logic_1.CommonLogic.nowToDateTime()
        });
    };
    JobBuilder.initialiseAccessoryCadModelImport = function (accessoryId, accessoryModelId, cadFile) {
        var input = {
            accessoryCadModelImport: {
                accessoryId: accessoryId,
                accessoryModelId: accessoryModelId,
                cadFile: cadFile
            }
        };
        return new JobBuilder({
            id: core_common_logic_1.CommonLogic.generateUUIDv4(),
            partyId: CrmDefaults_1.CrmDefaults.platformPartyId,
            type: JobType.ACCESSORY_CAD_MODEL_IMPORT,
            state: JobState.CREATED,
            input: input,
            output: JobOutput.EMPTY,
            scheduledToStartAt: core_common_logic_1.CommonLogic.nowToDateTime(),
            createdAt: core_common_logic_1.CommonLogic.nowToDateTime()
        });
    };
    JobBuilder.initialisePieceImagesGenerate = function (cameraSnapshots, designerCatalog) {
        var input = {
            pieceImagesGenerate: {
                cameraSnapshots: cameraSnapshots,
                designerCatalog: designerCatalog
            }
        };
        return new JobBuilder({
            id: core_common_logic_1.CommonLogic.generateUUIDv4(),
            partyId: CrmDefaults_1.CrmDefaults.platformPartyId,
            type: JobType.PIECE_IMAGES_GENERATE,
            state: JobState.CREATED,
            input: input,
            output: JobOutput.EMPTY,
            scheduledToStartAt: core_common_logic_1.CommonLogic.nowToDateTime(),
            createdAt: core_common_logic_1.CommonLogic.nowToDateTime()
        });
    };
    JobBuilder.initialiseAccessoryImagesGenerate = function (cameraSnapshots, designerCatalog) {
        var input = {
            accessoryImagesGenerate: {
                cameraSnapshots: cameraSnapshots,
                designerCatalog: designerCatalog
            }
        };
        return new JobBuilder({
            id: core_common_logic_1.CommonLogic.generateUUIDv4(),
            partyId: CrmDefaults_1.CrmDefaults.platformPartyId,
            type: JobType.ACCESSORY_IMAGES_GENERATE,
            state: JobState.CREATED,
            input: input,
            output: JobOutput.EMPTY,
            scheduledToStartAt: core_common_logic_1.CommonLogic.nowToDateTime(),
            createdAt: core_common_logic_1.CommonLogic.nowToDateTime()
        });
    };
    JobBuilder.initialiseMerchantCatalogImagesGenerate = function (merchantChannelCatalogId, partyId, channelId, configuration, merchantChannelCatalogCollections) {
        var input = {
            merchantCatalogImagesGenerate: {
                merchantChannelCatalogId: merchantChannelCatalogId,
                partyId: partyId,
                channelId: channelId,
                configuration: configuration,
                merchantChannelCatalogCollections: merchantChannelCatalogCollections
            }
        };
        return new JobBuilder({
            id: core_common_logic_1.CommonLogic.generateUUIDv4(),
            partyId: CrmDefaults_1.CrmDefaults.platformPartyId,
            type: JobType.MERCHANT_CATALOG_IMAGES_GENERATE,
            state: JobState.CREATED,
            input: input,
            output: JobOutput.EMPTY,
            scheduledToStartAt: core_common_logic_1.CommonLogic.nowToDateTime(),
            createdAt: core_common_logic_1.CommonLogic.nowToDateTime()
        });
    };
    JobBuilder.prototype.withId = function (id) {
        this.job.id = id;
        return this;
    };
    JobBuilder.prototype.getId = function () {
        return this.job.id;
    };
    JobBuilder.prototype.withState = function (state) {
        this.job.state = state;
        return this;
    };
    JobBuilder.prototype.build = function () {
        return this.job;
    };
    JobBuilder.prototype.buildUpdate = function () {
        return {
            partyId: this.job.partyId,
            merchantChannelId: this.job.merchantChannelId ? this.job.merchantChannelId : undefined,
            type: this.job.type,
            state: this.job.state,
            input: this.job.input,
            output: this.job.output,
            scheduledToStartAt: this.job.scheduledToStartAt ? this.job.scheduledToStartAt : undefined,
            createdAt: this.job.scheduledToStartAt ? this.job.createdAt : undefined,
            startedAt: this.job.scheduledToStartAt ? this.job.startedAt : undefined,
            finishedAt: this.job.scheduledToStartAt ? this.job.finishedAt : undefined
        };
    };
    return JobBuilder;
}());
exports.JobBuilder = JobBuilder;
